import { createStore } from '@orderx/lab/xr/store';
import { AppCache } from '../services/app-cache';
import { apiMetaPost } from '../api/meta.[post]';
import { useApiQuery } from '@orderx/lab/xr/http';
import { useEffect } from 'react';

type Meta = {
    areaCode: string;
    city: string;
    region: string;
    latitude: number;
    longitude: number;
    currency: string;
};

const { useStore } = createStore<Meta>(
    Object.assign(
        {
            areaCode: '',
            city: '',
            region: '',
            latitude: 0,
            longitude: 0,
            currency: '',
        },
        AppCache.get('meta'),
    ),
);

export function useMeta() {
    const [meta, setMeta] = useStore();

    //useAppCacheAutoSync('useMeta', meta);

    return {
        meta,
        useRegister() {
            const apiQuery = useApiQuery(async () => {
                setMeta(await apiMetaPost({}));
            });

            useEffect(() => {
                apiQuery.run();
            }, []);
        },
    };
}
